class collapseItemsQA extends HTMLElement {
    constructor(){
        super();

        this.btn_collapse = this.querySelectorAll('.circle');
        this.active = this.querySelector('.active');
        this.size = this.active.lastChild.previousElementSibling.scrollHeight;
        
    }

    connectedCallback(){
        this.active.lastChild.previousElementSibling.style.cssText = `height:${this.size}px;`;
        if(this.btn_collapse != null){
            this.btn_collapse.forEach(elm => elm.addEventListener('click', this.onClickCirclel.bind(this)))
        }
    }

    onClickCirclel(evt){
        evt.preventDefault();
        this.currentT = evt.currentTarget;
        this.element = this.currentT.parentNode.nextSibling.nextSibling;
        this.collapse = this.currentT.parentNode.parentNode;
        this._height = this.element.scrollHeight;

        if (!this.collapse.classList.contains('active')) {
            this.querySelector('.container-collapses').querySelectorAll('.collapses').forEach(elc => { 
                elc.classList.remove('active'); 
                elc.querySelector('.description').style.cssText = 'height: 0;' 
            });
            
            this.collapse.classList.add('active');
            this.element.style.cssText = `height: ${this._height}px;`;
        } else {
            this.collapse.classList.remove('active');
            this.element.style.cssText = `height: 0;`;
        }
    }
}
customElements.define('collapse-items',collapseItemsQA);

/**********************Collapse tabs Page INDIVIDUAL ARTICLE******************************/


/******************************************END COLLAPSE**********************************/
